import { ThreadsPostDetailModelV1 } from '@/types/threads';
import ThreadsUserInfo from '../ThreadsUserInfo';
import ThreadsPostContent from '../ThreadsPostContent';

interface ThreadsSearchResultProps {
  data: ThreadsPostDetailModelV1;
}

const ThreadsSearchResult = ({ data }: ThreadsSearchResultProps) => {
  return (
    <div className="max-w-[984px] mx-auto mt-[38px] max-md:mt-[26px] flex flex-col gap-5 max-md:gap-8">
      <ThreadsUserInfo user={data.user} />
      <ThreadsPostContent post={data.post_detail} user={data.user} />
    </div>
  );
};

export default ThreadsSearchResult;
